// libs
import React, {Fragment, useState} from 'react';
// components
import PincodeListModal from './pincode-list-modal';
import ConfirmationBox from '../../components/confirmation-box';
import FormModal from './form-modal';
import PrintErrorMsg from '../../components/print-error-msg';
import Button from 'react-bootstrap/Button';
// config & functions 
import config from '../../config';

function Table({loadapidata, offset, list, urlAccountId, orgInfo, token, paginationNo}) {
    const [ShowPincodeModal, setShowPincodeModal] = useState(false);
    const [ShowFormModalBox, setShowFormModalBox] = useState(false);
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowData, setRowData] = useState({});
    const [RowId, setRowId] = useState(0);
    const deleteUrl = `${config.api.generic}/shipping-price`;

    const handlePincode = (rowData) => {
        setRowData(rowData);
        setShowPincodeModal(true);  
    }   

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowFormModalBox(false);
        setShowDeleteModalBox(true);
    }

    const handleUpdate = (rowId) => {
        setRowId(rowId);
        setShowDeleteModalBox(false);
        setShowFormModalBox(true);
    }

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '50px'}}>#</th>
                            <th style={{minWidth: '100px'}}>Shipping Price</th>
                            <th style={{minWidth: '200px'}}>Is COD</th>
                            <th style={{minWidth: '250px'}}>Is Default</th>
                            <th style={{minWidth: '250px'}}>Map Pincode</th>
                            <th style={{minWidth: '250px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data,i) => {
                            return <tr key={Math.random()}>
                                <td>{`${pNo}.${i+1}`}</td>
                                <td>{data.shipping_price}</td>
                                <td>{data?.is_cod?'Yes':'No'}</td>
                                <td>{data?.is_default?'Yes':'No'}</td>
                                <td><Button variant="secondary" onClick={() => handlePincode({'ppid': data.pk_id, 'shippingPrice': data?.shipping_price, 'isCod': data?.is_cod, 'isDefault': data?.is_default})} className="fs-14rem me-4 p-0 border-0 bg-transparent text-primary">Map Pincode</Button></td>
                                <td>
                                    <Button variant="secondary" onClick={() => handleUpdate(data.pk_id)} className="fs-14rem me-4 p-0 border-0 bg-transparent text-primary">Update</Button>
                                    <Button variant="secondary" onClick={() => handleDelete(data.pk_id)} className="fs-14rem me-4 p-0 border-0 bg-transparent text-danger">Delete</Button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowPincodeModal) ? <PincodeListModal urlaccountid={urlAccountId} setshowformmodalbox={setShowPincodeModal} rowdata={RowData} token={token} orginfo={orgInfo} /> : null}
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={{rowId: RowId, accountId: urlAccountId}} token={token} /> : null}
            {(ShowFormModalBox) ? <FormModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowformmodalbox={setShowFormModalBox} orgaccountid={urlAccountId} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
        </>
    } else {
        return <PrintErrorMsg msg={'No order items available'} />;
    }
}

export default Table;
